<template>
  <section class="mt-2">
    <apexchart
      v-if="series"
      :key="`expense_chart${refkey}`"
      type="bar"
      height="230"
      :ref="`expense_chart${refkey}`"
      :options="chartOptions"
      :series="series"
    ></apexchart>

    <!-- :ref="`expense_chart${refkey}`" -->
  </section>
</template>
        
<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import dashboardStoreModule from "../dashboardStoreModule";

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },
  data() {
    return {
      chartOptions: {
        // colors : ['#ff0000', '#4576b5', '#224ffc', '#5e90c4', '#b7c1cf', '#219652', '#d5f6ff'],
        chart: {
          type: "bar",
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: false,
            columnWidth: "55%",
            // endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: this.categories,
        },
        title: {
          align: "left",
        },
        fill: {
          opacity: 1,
        },
        legend: {
          show: false,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return "$" + val;
            },
          },
        },
      },
    };
  },
  watch: {
    // refkey: {
    //   handler() {
    //     this.changeExpense();
    //   },
    //   immediate: true,
    // },
  },
  methods: {
    changeExpense() {
      var k = "expense_chart" + this.refkey;
        this.$refs[k].updateSeries(
          [
            {
              data: this.series[0].data,
            },
          ],
          false,
          true
        );

        this.$refs[k].updateOptions({
          xaxis: {
            categories: this.categories,
          },
        });

        this.$refs[k].refresh()
    },
  },
  mounted() {
    this.changeExpense();
  },
  props: {
    series: {
      type: Array,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    refkey: {},
  },
  computed: {},
  setup(props) {},
};
</script>
        
  <style lang="scss" scoped>
.apexcharts-toolbar {
  display: none;
}
</style>
        
    <style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
</style>
        